import { render, staticRenderFns } from "./BssRow.vue?vue&type=template&id=4062d6c1&scoped=true&"
import script from "./BssRow.vue?vue&type=script&lang=ts&"
export * from "./BssRow.vue?vue&type=script&lang=ts&"
import style0 from "./BssRow.vue?vue&type=style&index=0&id=4062d6c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4062d6c1",
  null
  
)

export default component.exports